import React, { useContext } from "react";
import { GlobalDataContext } from "../context/context";
import TransparentHeader from "../components/global/TransparentHeader3";
import BaseLayout from "../components/global/BaseLayout";
import ValuesOne from "../components/values/Values_1";
import BlockPrincipal from "../components/block/Block_10";
import BlockSecondary from "../components/block/Block_8";

function About() {
  const { rpdata } = useContext(GlobalDataContext);
  return (
    <BaseLayout PageName="About">
      <div className="md:max-w-full w-full">
        <TransparentHeader
          headertitle="About"
          Subheader="About"
          bgimg={`${rpdata?.gallery?.[40]}`}
        />
        <BlockPrincipal
          title={rpdata?.dbSlogan?.[7]?.slogan}
          text={rpdata?.dbAbout?.[0]?.text}
          image1={rpdata?.gallery?.[0]}
          image2={rpdata?.gallery?.[11]}
          image3={rpdata?.gallery?.[5]}
          listsAbout
        />
        <ValuesOne image={rpdata?.gallery?.[25]} />

        <BlockSecondary
          title={rpdata?.dbSlogan?.[2]?.slogan}
          text={rpdata?.dbAbout?.[1]?.text}
          image1={rpdata?.gallery?.[30]}
          image2={rpdata?.gallery?.[12]}
          image3={rpdata?.gallery?.[10]}
        />
      </div>
    </BaseLayout>
  );
}

export default About;
